import React from 'react';
import { getCmsImagePath } from '../cms/cmsData';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import './TermsOfUse.css';

const KeemokaziGiveawayRules = () => {
  return (
    <div className="page-wrapper">
      <AnnouncementBar />

      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        <TornPaperWrapper>
          <h1 className="card-title">KEEMOKAZI OC MENA FESTIVAL GIVEAWAY – OFFICIAL RULES</h1>
          <div className="legal-content">
            <p><strong>NO PURCHASE NECESSARY TO ENTER OR WIN.</strong></p>

            <h2>1. SPONSOR</h2>
            <p>This giveaway is sponsored by MENA Events Inc, located at 1240 S State College Ave Suite 200, Anaheim, CA 92806 (“Sponsor”).</p>
            <p>This promotion is not sponsored, endorsed, administered by, or associated with Instagram or TikTok.</p>

            <h2>2. ELIGIBILITY</h2>
            <p>Open to legal residents of the United States who are:</p>
            <ul>
              <li>At least 18 years of age at the time of entry</li>
            </ul>
            <p>Void where prohibited by law.</p>

            <h2>3. PROMOTION PERIOD</h2>
            <p>The giveaway begins upon the first announcement post by Keemokazi and ends on June 21, 2026 at the conclusion of the meet &amp; greet appearance (approximately 4:30 PM PST).</p>

            <h2>4. HOW TO ENTER</h2>
            <p>To enter the giveaway, participants must:</p>
            <ul>
              <li>Attend the OC MENA Festival on June 21, 2026</li>
              <li>Visit the Keemokazi meet &amp; greet booth or designated festival stage area during the scheduled appearance</li>
              <li>Complete an entry by submitting their name into the official raffle drawing at the event</li>
            </ul>
            <p>No purchase is necessary to enter or win. Entry is limited to one (1) submission per person unless otherwise determined by Sponsor.</p>

            <h2>5. PRIZES</h2>
            <p>Five (5) winners will each receive $1,000 USD</p>
            <p>Total prize value: $5,000 USD</p>
            <p>Prizes are:</p>
            <ul>
              <li>Non-transferable</li>
              <li>Not redeemable for substitution</li>
            </ul>

            <h2>6. WINNER SELECTION</h2>
            <p>Winners will be selected at random from all eligible entries received.</p>
            <p>Winners will be drawn and announced during the meet &amp; greet on June 21, 2026.</p>
            <p>Sponsor reserves the right to verify eligibility prior to awarding prizes.</p>

            <h2>7. PRIZE DELIVERY</h2>
            <p>Prizes will be distributed in person at the meet &amp; greet booth or designated area.</p>
            <p>Winners must be present at the time of drawing unless otherwise determined by Sponsor.</p>

            <h2>8. PUBLICITY RELEASE</h2>
            <p>By entering, participants agree to allow Sponsor and its designees to use their:</p>
            <ul>
              <li>Name</li>
              <li>Likeness</li>
              <li>Image</li>
            </ul>
            <p>for promotional purposes without additional compensation, unless prohibited by law.</p>

            <h2>9. GENERAL CONDITIONS</h2>
            <p>Sponsor reserves the right to:</p>
            <ul>
              <li>Modify, suspend, or terminate the giveaway if necessary</li>
              <li>Disqualify any participant who tampers with the process or violates these rules</li>
            </ul>

            <h2>10. LIMITATION OF LIABILITY</h2>
            <p>By participating, entrants agree to release and hold harmless:</p>
            <ul>
              <li>MENA Events Inc</li>
              <li>Keemokazi</li>
              <li>Associated partners</li>
            </ul>
            <p>from any claims arising out of participation or prize acceptance.</p>

            <h2>11. FTC DISCLOSURE</h2>
            <p>This giveaway is sponsored and funded by MENA Events Inc. Promotional content related to this giveaway may include paid partnerships or endorsements.</p>

            <h2>12. GOVERNING LAW</h2>
            <p>This promotion is governed by the laws of the State of California.</p>
          </div>
        </TornPaperWrapper>

        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath('lanterns', '/lanterns.webp')} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      <SponsorsSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default KeemokaziGiveawayRules;
